import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m4nc6munyv: FaireBrandEntity = {
  token: "b_m4nc6munyv",
  type: "brand",
  name: "Rosa Clothing",
  avatarUrl:
    "https://cdn.faire.com/fastly/7ee83b7e5a171e75f477d42abdfa73b1df7b4fa08dffa6c5a53ab0731b860b62.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/738bc7ed65a2217faba9055bf52329b9106bd88ab93462520583474987459c3c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7ee83b7e5a171e75f477d42abdfa73b1df7b4fa08dffa6c5a53ab0731b860b62.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/738bc7ed65a2217faba9055bf52329b9106bd88ab93462520583474987459c3c.jpeg",
  location: "Whittier, CA, USA",
  minimumOrderDollars: 208,
  rating: 4.1,
  reviewCount: 716,
  isInsider: true,
  description:
    "Rosa Clothing is a new and growing company based in California. Our company mainly focuses on women's wear and adheres to the concept that everyone can enjoy the beauty of fashion. Our brand is operated by professional designers, manufacturers, and photographers. Rosa clothing aims to provide the highest value trendy pieces while also being dedicated to quality, value, and service.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:44.022Z",
    importedBy: "entity-db-cli",
  },
};
